import React from 'react';
import { ChevronLeft, CircleSmall } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './timeframe-navigation-buttons.style';

export type TimeframeNavigationButtonsProps = {
  onPrev: () => void;
  onToday: () => void;
  onNext: () => void;
  isNextDisabled?: boolean;
  hasDarkBackground?: boolean;
};

export const TimeframeNavigationButtons: React.FC<
  TimeframeNavigationButtonsProps
> = ({ onPrev, onToday, onNext, isNextDisabled, hasDarkBackground }) => {
  const handleNext = () => {
    if (isNextDisabled) {
      return;
    }
    onNext();
  };

  return (
    <Styled.Container $hasDarkBackground={hasDarkBackground}>
      <Styled.Button onClick={onPrev} type="button">
        <Icon icon={ChevronLeft} />
      </Styled.Button>
      <Styled.Button onClick={onToday} type="button">
        <Icon icon={CircleSmall} />
      </Styled.Button>
      <Styled.Button
        onClick={handleNext}
        type="button"
        $rotated
        $disabled={isNextDisabled}
        disabled={isNextDisabled}
      >
        <Icon icon={ChevronLeft} />
      </Styled.Button>
    </Styled.Container>
  );
};
